module.exports = {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
  REACT_APP_GOOGLE_APP_ID: process.env.REACT_APP_GOOGLE_APP_ID,
  REACT_APP_GOOGLE_CAPCHA_KEY: process.env.REACT_APP_GOOGLE_CAPCHA_KEY,
  APP_ENV: process.env.REACT_APP_ENV,
};
